var _objectAssign = require('./_objectAssign');

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_assign.js
// module id = 1551
// module chunks = 0